import './dropzonejs/dropzone.css'
import vueDropzone from './vuedropzone/vue-dropzone'

export default vueDropzone
